import { COLORS } from '@btime/constants'
import React from 'react'

import { PermissionChecker } from '../../session'
import { getQueryParam } from '../../../packages/kiti/utils/helpers/url'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'
import AddNewButton from '../list/AddNewButton'
import CalendarLoader from './_load/CalendarLoader'
import Content from './Content'
import FilterWrapper from '../list/filters/FilterWrapper'
import MultiRowsActions from './MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PageHeader from '../list/PageHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'

const ServiceOrdersKanbanPage = ({ id }) => {
  useLocalStorageWatcher('SERVICE_ORDERS_LAST_SCREEN', 'calendar')
  const demo = getQueryParam('d')

  return (
    <SideMenuTemplate bgColor={COLORS.white}>
      <Separator weight={6} flex={1}>
        <PermissionChecker permission="listServiceOrder">
          <FilterWrapper>
            <MultiSelectHandler>
              <PageHeader />

              <CalendarLoader>
                <Content />
              </CalendarLoader>
              <Separator weight={50} />
              <MultiRowsActions />
            </MultiSelectHandler>
            <AddNewButton />
          </FilterWrapper>
        </PermissionChecker>
      </Separator>
    </SideMenuTemplate>
  )
}

export default ServiceOrdersKanbanPage
